export function getItems(active, total) {
  var result = [];
  var left = Math.max(Math.min(active - 2, total - 4), 1);
  var right = Math.min(Math.max(5, active + 2), total);
  var hasLeftDots = left > 3;
  var from = hasLeftDots ? left : 1;
  var hasRightDots = right < total - 2;
  var to = hasRightDots ? right : total;

  if (hasLeftDots) {
    result.push(1, '.');
  }

  for (var i = from; i <= to; ++i) {
    result.push(i);
  }

  if (hasRightDots) {
    result.push('.');
  }

  if (hasRightDots && isFinite(total)) {
    result.push(total);
  }

  return result;
}